
export function isNumber(value: string | number): boolean {
  return ((value != null) && (value !== '') && !isNaN(Number(value.toString())));
}

export function capitalizeFirstLetter(text: string) {
  return text.charAt(0).toUpperCase() + text.slice(1);
}
